import { Navigate, Outlet } from "react-router-dom";
import { HOME, SOLO_ACTIVA } from "../../config/producto";

/**
 * Envuelve las rutas legacy en App.tsx. Con SOLO_ACTIVA, cualquier URL de la plataforma anterior
 * (un bookmark, un deep-link viejo, el SSO) termina en el inicio (HOME) en vez de mostrar pantallas
 * de demo con "brand-demo" o que simulan envíos. Sin SOLO_ACTIVA, deja pasar.
 *
 * Iba a /activa, fijo: cuando el inicio pasó a ser el Resumen de WhatsApp (07/10/2026), el login, el
 * logo, «/» y el comodín se movieron con HOME y esto quedó atrás. Un link viejo abría la lista de
 * campañas por archivo, una sección del menú, en vez de la pantalla con la que arranca todo lo demás.
 */
export const SoloActiva = () => {
  if (SOLO_ACTIVA) return <Navigate to={HOME} replace />;
  return <Outlet />;
};

export default SoloActiva;
